<template>
  <li
    :data-gtm="exhibitionTitle"
    class="
      $typography/size:large
      dvg-map-exhibition-card
      link/cursor
    "
    @click="handleClick"
    >
    <div
      class="
        @600/layout/width:min
        layout/ratio:3:2
        layout/width:min
      "
      style="
        --600--layout--width--min: 18rem;
        --layout--width--min: 24.5rem;
      "
      >
      <picture class="picture">
        <img
          class="
            picture/image:crop
          "
          :src="exhibition?.Asset?.URL"
          :alt="exhibition.Title"
        >
      </picture>
    </div>
    <div class="layout/padding:top:cap">
      <p
        v-if="currentStatus"
        class="
          $color/session
          $typography/size:medium
          color
          typography
        "
        v-html="currentStatus"
      />
      <h3
        class="
          layout/margin:left:clear
          typography
          "
        v-html="exhibitionTitle"
      />
      <p
        class="
          $color/gray:767
          $typography/scale:down
          color
          typography
        "
        v-html="locationName"
      />
    </div>
  </li>
</template>

<script>
  import { getExhibitionOverlayData, getExhibitionStatus } from 'Helpers/dvg-helpers/map-page-helpers';
  export default {
    props: {
      exhibition: {
        type: Object,
        required: true
      },
      setHighlightedElement: {
        type: Function,
        required: true
      },
      showDrawer: {
        type: Function,
        required: true
      }
    },
    computed: {
      exhibitionTitle() {
        if (this.exhibition.Type === 'mde' && this.exhibition.Data.Subtitle) {
          return `${this.exhibition.Title}: ${this.exhibition.Data.Subtitle}`;
        } else {
          return this.exhibition.Title;
        }
      },
      locationName() {
        return this.exhibition.LocationName;
      },
      currentStatus() {
        return getExhibitionStatus(this.exhibition);
      }
    },
    methods: {
      handleClick() {
        this.setHighlightedElement(this.exhibition.LocationName);
        this.showDrawer(getExhibitionOverlayData(this.exhibition));
      }
    }
  };
</script>